import HomePage from "../components/homePage/HomePage";

function Home() {
  return <HomePage />;
}
export default Home;
